// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Resizable-module__handle___eNvX {
  position: fixed;
  top: 86px;
  height: calc(100% - 92px);
  width: 1px;
  margin-left: -2px;
  margin-top: 8px;
  z-index: 100;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ew-resize;
  border: none;
}
.Resizable-module__handle___eNvX:focus {
  cursor: ew-resize;
}
.react-resizable {
  position: relative;
}
.react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-origin: content-box;
  box-sizing: border-box;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom right;
  padding: 0 3px 3px 0;
}
.react-resizable-handle-sw {
  bottom: 0;
  left: 0;
  cursor: sw-resize;
  transform: rotate(90deg);
}
.react-resizable-handle-se {
  bottom: 0;
  right: 0;
  cursor: se-resize;
}
.react-resizable-handle-nw {
  top: 0;
  left: 0;
  cursor: nw-resize;
  transform: rotate(180deg);
}
.react-resizable-handle-ne {
  top: 0;
  right: 0;
  cursor: ne-resize;
  transform: rotate(270deg);
}
.react-resizable-handle-w,
.react-resizable-handle-e {
  top: 50%;
  margin-top: -10px;
  cursor: ew-resize;
}
.react-resizable-handle-w {
  left: 0;
  transform: rotate(135deg);
}
.react-resizable-handle-e {
  right: 0;
  transform: rotate(315deg);
}
.react-resizable-handle-n,
.react-resizable-handle-s {
  left: 50%;
  margin-left: -10px;
  cursor: ns-resize;
}
.react-resizable-handle-n {
  top: 0;
  transform: rotate(225deg);
}
.react-resizable-handle-s {
  bottom: 0;
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/Resizable/Resizable.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AACF;AAEA;EACE,iBAAA;AAAF;AAGA;EACE,kBAAA;AADF;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,yDAAA;EACA,iCAAA;EACA,oBAAA;AADF;AAGA;EACE,SAAA;EACA,OAAA;EACA,iBAAA;EACA,wBAAA;AADF;AAGA;EACE,SAAA;EACA,QAAA;EACA,iBAAA;AADF;AAGA;EACE,MAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;AADF;AAGA;EACE,MAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;AADF;AAGA;;EAEE,QAAA;EACA,iBAAA;EACA,iBAAA;AADF;AAGA;EACE,OAAA;EACA,yBAAA;AADF;AAGA;EACE,QAAA;EACA,yBAAA;AADF;AAGA;;EAEE,SAAA;EACA,kBAAA;EACA,iBAAA;AADF;AAGA;EACE,MAAA;EACA,yBAAA;AADF;AAGA;EACE,SAAA;EACA,wBAAA;AADF","sourcesContent":[".handle {\n  position: fixed;\n  top: 86px;\n  height: calc(100% - 92px);\n  width: 1px;\n  margin-left: -2px;\n  margin-top: 8px;\n  z-index: 100;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: ew-resize;\n  border: none;\n}\n\n.handle:focus {\n  cursor: ew-resize;\n}\n\n:global(.react-resizable) {\n  position: relative;\n}\n:global(.react-resizable-handle) {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-origin: content-box;\n  box-sizing: border-box;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+');\n  background-position: bottom right;\n  padding: 0 3px 3px 0;\n}\n:global(.react-resizable-handle-sw) {\n  bottom: 0;\n  left: 0;\n  cursor: sw-resize;\n  transform: rotate(90deg);\n}\n:global(.react-resizable-handle-se) {\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n}\n:global(.react-resizable-handle-nw) {\n  top: 0;\n  left: 0;\n  cursor: nw-resize;\n  transform: rotate(180deg);\n}\n:global(.react-resizable-handle-ne) {\n  top: 0;\n  right: 0;\n  cursor: ne-resize;\n  transform: rotate(270deg);\n}\n:global(.react-resizable-handle-)w,\n:global(.react-resizable-handle-e) {\n  top: 50%;\n  margin-top: -10px;\n  cursor: ew-resize;\n}\n:global(.react-resizable-handle-w) {\n  left: 0;\n  transform: rotate(135deg);\n}\n:global(.react-resizable-handle-e) {\n  right: 0;\n  transform: rotate(315deg);\n}\n:global(.react-resizable-handle-)n,\n:global(.react-resizable-handle-s) {\n  left: 50%;\n  margin-left: -10px;\n  cursor: ns-resize;\n}\n:global(.react-resizable-handle-n) {\n  top: 0;\n  transform: rotate(225deg);\n}\n:global(.react-resizable-handle-s) {\n  bottom: 0;\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"handle": `Resizable-module__handle___eNvX`
};
export default ___CSS_LOADER_EXPORT___;
